import {
  Circle,
  CircleX,
  Clock,
  GitMerge,
  LoaderCircle,
  type LucideIcon,
  MessageCircleQuestion,
  OctagonAlert,
  Stamp,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { TONE_TEXT, type Tone } from "../lib/status";
import { MOOD_TEXT, type TaskMood } from "../lib/tasks";

const MOOD: Record<TaskMood, { icon: LucideIcon; tone: Tone }> = {
  working: { icon: LoaderCircle, tone: "sky" },
  waiting: { icon: Clock, tone: "neutral" },
  blocked: { icon: OctagonAlert, tone: "amber" },
  failed: { icon: CircleX, tone: "red" },
  input: { icon: MessageCircleQuestion, tone: "violet" },
  approve: { icon: Stamp, tone: "amber" },
  human: { icon: MessageCircleQuestion, tone: "violet" },
  merging: { icon: GitMerge, tone: "sky" },
  idle: { icon: Circle, tone: "neutral" },
};

export function MoodIcon({ mood, className }: { mood: TaskMood; className?: string }) {
  const { icon: Icon, tone } = MOOD[mood];
  return (
    <Icon
      aria-label={MOOD_TEXT[mood]}
      className={cn("size-3.5 shrink-0", TONE_TEXT[tone], mood === "working" && "animate-spin", className)}
    />
  );
}
